import { toast } from "sonner";
import { Laptop, Smartphone, Check, Trash2 } from "lucide-react";
import { api } from "../lib/api";

const PLATFORMS = [
  { key: "windows", label: "Laptop (Windows)", Icon: Laptop },
  { key: "android", label: "Android", Icon: Smartphone },
];

function Slot({ u, p, reload }) {
  const cur = (u.devices || {})[p.key];
  const pend = (u.device_pending || {})[p.key];
  const call = async (fn, ok) => { try { await fn(); toast.success(ok); reload(); } catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); } };
  return (
    <div data-testid={`hwid-slot-${p.key}-${u.email}`} className="rounded-lg border border-slate-800 bg-[#0c1017] p-3">
      <div className="flex items-center gap-1.5 text-xs font-bold text-slate-300 mb-2"><p.Icon className="h-3.5 w-3.5" />{p.label}</div>
      <div className="text-[10px] uppercase tracking-wider text-slate-500">Aktif</div>
      <div data-testid={`hwid-active-${p.key}-${u.email}`} className="font-mono-tt text-sm text-emerald-300 break-all">{cur ? cur.hwid : "—"}</div>
      {cur?.model && <div className="text-[10px] text-slate-500">{cur.model} · v{cur.ver}</div>}
      {pend && (
        <div className="mt-2 rounded border border-amber-700/40 bg-amber-500/5 p-2">
          <div className="text-[10px] uppercase tracking-wider text-amber-400">Menunggu aktivasi</div>
          <div data-testid={`hwid-pending-${p.key}-${u.email}`} className="font-mono-tt text-sm text-amber-200 break-all">{pend.hwid}</div>
          <div className="text-[10px] text-slate-500">{pend.model} · v{pend.ver}</div>
        </div>
      )}
      <div className="flex gap-1.5 mt-2">
        {pend && <button data-testid={`hwid-approve-${p.key}-${u.email}`} onClick={() => call(() => api.post(`/auth/users/${u.user_id}/devices/${p.key}/approve`), "HWID diaktivasi")}
          className="flex-1 inline-flex items-center justify-center gap-1 text-[11px] px-2 py-1.5 rounded bg-emerald-600/80 hover:bg-emerald-500 text-slate-950 font-bold"><Check className="h-3 w-3" />{cur ? "Ganti" : "Aktivasi"}</button>}
        {(cur || pend) && <button data-testid={`hwid-remove-${p.key}-${u.email}`} onClick={() => call(() => api.delete(`/auth/users/${u.user_id}/devices/${p.key}`), "HWID dihapus")}
          className="inline-flex items-center gap-1 text-[11px] px-2 py-1.5 rounded bg-slate-700 hover:bg-slate-600 text-slate-100 font-bold"><Trash2 className="h-3 w-3" />Hapus</button>}
      </div>
    </div>
  );
}

export function DevicePanel({ u, reload }) {
  const toggleDev = async () => {
    try { await api.post(`/auth/users/${u.user_id}/dev-access`, { enabled: !u.dev_access }); toast.success(u.dev_access ? "Akses develope dimatikan" : "Akses develope aktif"); reload(); }
    catch (_) { toast.error("Gagal"); }
  };
  return (
    <div className="lg:w-80 shrink-0" data-testid={`hwid-panel-${u.email}`}>
      <div className="text-xs font-bold uppercase tracking-widest text-slate-400 mb-2">Perangkat (HWID)</div>
      <div className="space-y-2">{PLATFORMS.map((p) => <Slot key={p.key} u={u} p={p} reload={reload} />)}</div>
      <label data-testid={`dev-access-toggle-${u.email}`} onClick={toggleDev} className={`mt-3 flex items-center gap-2 px-3 py-2 rounded-lg border cursor-pointer ${u.dev_access ? "border-sky-600/50 bg-sky-500/10" : "border-slate-800 bg-[#0c1017]"}`}>
        <span className={`h-4 w-4 rounded flex items-center justify-center ${u.dev_access ? "bg-sky-500" : "bg-slate-700"}`}>{u.dev_access && <Check className="h-3 w-3 text-slate-950" />}</span>
        <span className="text-xs text-slate-300">Akun develope — boleh login di web & perangkat apa pun</span>
      </label>
    </div>
  );
}
